var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 0H60C26.8629 0 0 26.8629 0 60V196C0 229.137 26.8629 256 60 256H196C229.137 256 256 229.137 256 196V60C256 26.8629 229.137 0 196 0Z",
    fill: "#F4F2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.001 146.951C138.305 146.951 146.657 138.598 146.657 128.295C146.657 117.992 138.305 109.639 128.001 109.639C117.698 109.639 109.345 117.992 109.345 128.295C109.345 138.598 117.698 146.951 128.001 146.951Z",
    fill: "#00D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.002 90.363C153.05 90.363 176.319 93.957 193.864 99.998C215.003 107.275 228 118.306 228 128.295C228 138.704 214.226 150.423 191.525 157.944C174.363 163.63 151.779 166.598 128.002 166.598C103.624 166.598 80.539 163.812 63.183 157.881C41.225 150.376 28 138.506 28 128.295C28 118.387 40.41 107.441 61.252 100.175C78.862 94.035 102.705 90.363 127.998 90.363H128.002Z",
    stroke: "#00D8FF",
    strokeWidth: 8.911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.981 109.438C107.495 87.74 122.232 69.378 136.23 57.198C153.094 42.521 169.144 36.773 177.796 41.762C186.813 46.962 190.084 64.75 185.259 88.172C181.614 105.879 172.9 126.925 161.021 147.523C148.842 168.641 134.897 187.247 121.09 199.315C103.619 214.587 86.728 220.114 77.883 215.013C69.3 210.067 66.018 193.846 70.136 172.161C73.615 153.838 82.346 131.349 94.977 109.438H94.981Z",
    stroke: "#00D8FF",
    strokeWidth: 8.911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.012 147.578C82.463 125.904 73.919 103.962 70.353 85.7521C66.06 63.8111 69.095 47.0361 77.74 42.0321C86.749 36.8161 103.792 42.8661 121.674 58.7441C135.194 70.7481 149.077 88.8051 160.99 109.383C173.204 130.481 182.358 151.856 185.919 169.844C190.425 192.608 186.778 210.001 177.941 215.116C169.367 220.08 153.676 214.825 136.945 200.427C122.809 188.263 107.685 169.468 95.012 147.578Z",
    stroke: "#00D8FF",
    strokeWidth: 8.911
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.4c65ea1584c2e57ad0236ba799035c14.svg";
export { ForwardRef as ReactComponent };